/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	OrgUnitReserveUpdatePartialUpdatePathOrgUnitId,
	OrgUnitReserveUpdatePartialUpdatePathReserveId,
	OrgUnitReserveUpdatePartialUpdateData,
	OrgUnitReserveUpdatePartialUpdateStatus200,
} from "../types/OrgUnitReserveUpdatePartialUpdate.ts";

function getOrgUnitReserveUpdatePartialUpdateUrl(
	org_unit_id: OrgUnitReserveUpdatePartialUpdatePathOrgUnitId,
	reserve_id: OrgUnitReserveUpdatePartialUpdatePathReserveId,
) {
	const res = { method: "PATCH", url: `/api/org_unit/${org_unit_id}/reserve/${reserve_id}/update/` as const };

	return res;
}

/**
 * @description Общая выборка и перечитывание брони для операций изменения.
 * @summary перенос брони на другое время или стол
 * {@link /api/org_unit/:org_unit_id/reserve/:reserve_id/update/}
 */
export async function orgUnitReserveUpdatePartialUpdate(
	org_unit_id: OrgUnitReserveUpdatePartialUpdatePathOrgUnitId,
	reserve_id: OrgUnitReserveUpdatePartialUpdatePathReserveId,
	data?: OrgUnitReserveUpdatePartialUpdateData,
	config: Partial<RequestConfig<OrgUnitReserveUpdatePartialUpdateData>> & { client?: Client; contentType?: "application/json" | "application/xml" } = {},
) {
	const { client: request = client, contentType = "application/json", ...requestConfig } = config;

	const requestData = data;

	const res = await request<OrgUnitReserveUpdatePartialUpdateStatus200, ResponseErrorConfig<Error>, OrgUnitReserveUpdatePartialUpdateData>({
		method: "PATCH",
		url: getOrgUnitReserveUpdatePartialUpdateUrl(org_unit_id, reserve_id).url.toString(),
		data: requestData,
		contentType,
		...requestConfig,
	});

	return res.data;
}
